module.exports = __webpack_public_path__ + "img/acCharge_online.bf1cd197.png";